/**
* This is an automatically generated file. Do not change it manually
*/
import {IThemeBoxes} from "../../../services/theme/theme-boxes.interface";
import {ButtonLabelPaddingCasino888Box} from "../../../basic-ui-components/button/base/boxes/label-padding-box/button-label-padding.casino888.box";
import {LobbyHeaderLineCasino888Box} from "../../../components/lobby-header/boxes/line/lobby-header-line.casino888.box";
import {LobbyHeaderTitleCasino888Box} from "../../../components/lobby-header/boxes/title/lobby-header-title.casino888.box";
import {LogoContainerCasino888Box} from "../../../components/user-menu/logo-box/boxes/logo-container/logo-container.casino888.box";
import {SearchInputAreaCasino888Box} from "../../../components/game-search/search-input/search-input-area/boxes/search-input-area-box/search-input-area.casino888.box";
import {UserMenuHeaderCasino888Box} from "../../../components/user-menu/user-menu/boxes/header/user-menu-header.casino888.box";

export const ThemeBoxes: Partial<IThemeBoxes> = {
	ButtonLabelPaddingBox: ButtonLabelPaddingCasino888Box,
	LobbyHeaderLineBox: LobbyHeaderLineCasino888Box,
	LobbyHeaderTitleBox: LobbyHeaderTitleCasino888Box,
	LogoContainerBox: LogoContainerCasino888Box,
	SearchInputAreaBox: SearchInputAreaCasino888Box,
	UserMenuHeaderBox: UserMenuHeaderCasino888Box,
}